/**
 * Утилиты для работы с URL
 */

/**
 * Преобразует относительный URL в полный URL
 * @param url - относительный или абсолютный URL
 * @returns полный URL
 */
export function resolveUrl(url: string): string {
  // Если URL уже абсолютный (http или https), возвращаем как есть
  if (/^https?:\/\//i.test(url)) return url;
  
  // Получаем базовый URL API
  const base = (process.env.REACT_APP_API_BASE_URL || '/api/v1').toString().trim().replace(/\/+$/, '');
  
  // Если URL начинается с /, добавляем к базовому URL
  if (url.startsWith('/')) return `${base}${url}`;
  
  // Иначе добавляем / между базовым URL и относительным путем
  return `${base}/${url}`;
}

/**
 * Преобразует URL логотипа в полный URL
 * @param logoUrl - URL логотипа (может быть относительным)
 * @returns полный URL логотипа
 */
export function resolveLogoUrl(logoUrl?: string): string | undefined {
  if (!logoUrl) return undefined;
  return resolveUrl(logoUrl);
}

/**
 * Возвращает абсолютный URL (без кэша) — вспомогательно для кэш-утилит
 */
export function toAbsoluteUrl(url?: string | null): string | undefined {
  if (!url) return undefined;
  return resolveUrl(url);
}